module.exports = __webpack_public_path__ + "media/slider/Banner-10-1f31442c.jpg";